import { render, staticRenderFns } from "./OfficialApply.vue?vue&type=template&id=bfb60282&scoped=true"
import script from "./OfficialApply.vue?vue&type=script&lang=js"
export * from "./OfficialApply.vue?vue&type=script&lang=js"
import style0 from "./OfficialApply.vue?vue&type=style&index=0&id=bfb60282&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfb60282",
  null
  
)

export default component.exports